import { SEO } from './seo-config'

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.content = content
}

function upsertLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`)
  if (!el) {
    el = document.createElement('link')
    el.rel = rel
    document.head.appendChild(el)
  }
  el.href = href
}

export type PageMeta = {
  title: string
  description: string
  canonical: string
  type?: 'website' | 'article' | 'profile'
  robots?: string
}

/** Sync document <head> with the current route's metadata. */
export function applyPageMeta({ title, description, canonical, type = 'website', robots = 'index, follow' }: PageMeta) {
  const { name, themeColor, twitterHandle, ogImage } = SEO
  const imageAlt = `${name} — ${SEO.jobTitle}`

  document.title = title
  upsertMeta('name', 'description', description)
  upsertMeta('name', 'author', name)
  upsertMeta('name', 'theme-color', themeColor)
  upsertMeta('name', 'robots', robots)

  upsertMeta('property', 'og:type', type)
  upsertMeta('property', 'og:site_name', name)
  upsertMeta('property', 'og:title', title)
  upsertMeta('property', 'og:description', description)
  upsertMeta('property', 'og:url', canonical)
  upsertMeta('property', 'og:image', ogImage)
  upsertMeta('property', 'og:image:width', '1200')
  upsertMeta('property', 'og:image:height', '630')
  upsertMeta('property', 'og:image:alt', imageAlt)
  upsertMeta('property', 'og:locale', 'en_US')

  upsertMeta('name', 'twitter:card', 'summary_large_image')
  upsertMeta('name', 'twitter:site', twitterHandle)
  upsertMeta('name', 'twitter:creator', twitterHandle)
  upsertMeta('name', 'twitter:title', title)
  upsertMeta('name', 'twitter:description', description)
  upsertMeta('name', 'twitter:image', ogImage)
  upsertMeta('name', 'twitter:image:alt', imageAlt)

  upsertLink('canonical', canonical)
}
